/**
 * @file Modal containing navigation options for identities in album discovery.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withModal from '../global/modal/withModal';
import Button from '../global/Button';
import { DISCOVER_IDENTITY_NAV_MODAL } from '../../constants/modals';
import ContextualString from '../contextual/ContextualString';
import { isPrimaryIdentity } from '../../util/identity';
import { ALBUM_SUBTYPE } from '../../constants/albums';
import { getAsset } from '../../util/assets';
import { ALBUM_IDENTITY_ACCESS } from '../../constants/identity';
import withVirtualPageview from '../global/hoc/withVirtualPageview';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    album_identity_access: PropTypes.oneOf(
      Object.values(ALBUM_IDENTITY_ACCESS),
    ),
  }),
  identity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  albumFolderId: PropTypes.string.isRequired,
  switchIdentity: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
  onCompleteEnrollment: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  account: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const IdentityNav = ({
  identity,
  albumFolder,
  switchIdentity,
  albumFolderId,
  closeModal,
  onCompleteEnrollment,
}) => {
  const identityName = isPrimaryIdentity(identity) ? 'yourself' : identity.name;

  return (
    <div className="d-flex flex-column justify-content-center">
      <div className="text-center mt-3 mb-2">
        <img
          src={getAsset('/waldo-icon.svg')}
          alt="Waldo logo"
          width="60"
          className="mb-2"
        />

        <h3>Where to go next?</h3>
      </div>

      {albumFolder.album_identity_access !==
        ALBUM_IDENTITY_ACCESS.PRIMARY_ONLY && (
        <Fragment>
          <Button
            btnBlock
            btnStyle="yellow"
            className="btn-id-add-more mb-2"
            onClick={() => {
              closeModal(DISCOVER_IDENTITY_NAV_MODAL);
              switchIdentity();
            }}
          >
            <ContextualString
              id="consumerSelectAlbumsForOther"
              subtype={albumFolder.album_subtype}
              defaultMessage="Add another family member"
            />
          </Button>
        </Fragment>
      )}

      {((albumFolder.id !== albumFolderId &&
        albumFolder.album_subtype !== ALBUM_SUBTYPE.CAMPS &&
        albumFolder.album_subtype !== ALBUM_SUBTYPE.SCHOOLS) ||
        albumFolder.album_identity_access ===
          ALBUM_IDENTITY_ACCESS.PRIMARY_ONLY) && (
        <Button
          btnBlock
          btnStyle="yellow"
          className="btn-id-not-finished mb-2"
          to={`/discover/album-folder/${albumFolderId}/select`}
          onClick={() => closeModal(DISCOVER_IDENTITY_NAV_MODAL)}
        >
          <ContextualString
            id="consumerSelectAlbumsForCurrent"
            subtype={albumFolder.album_subtype}
            defaultMessage="Join {identityName} to more albums"
            values={{
              identityName,
            }}
          />
        </Button>
      )}

      <Button
        btnBlock
        className="btn-id-next"
        onClick={() => {
          closeModal(DISCOVER_IDENTITY_NAV_MODAL);
          onCompleteEnrollment();
        }}
      >
        Continue
      </Button>
    </div>
  );
};

IdentityNav.propTypes = propTypes;

export { IdentityNav };

export default withModal(
  withVirtualPageview({
    path: 'next-steps',
    title: 'Next Steps',
  })(IdentityNav),
  {
    name: DISCOVER_IDENTITY_NAV_MODAL,
    hideHeader: true,
    size: 'sm',
    type: 'full',
  },
);
